import "../styles/Recipe.css";
import '../styles/Buttons.css';
import React from 'react';
import { Link } from 'react-router-dom';

function TopNavbar2side(props) {
  const { title, sideTitle, buttonIcon, buttonHref, classN, onClick } = props;

  return (
    <div className="spc-between topnav-container">
      <p className="heading-1">{title}</p>

      <div className={classN}>
        {buttonIcon.map((icon, index) => (
          <Link to={buttonHref[index]}
          onClick={onClick}
           key={index} href={buttonHref[index]} className="spc-between">
            <span className={icon}></span>
            <p className="subject-2">{sideTitle}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TopNavbar2side;
